import React, { PropTypes } from 'react';
import { DragSource } from 'react-dnd';
import ItemTypes from '../../ItemTypes.js';
import uuidV4 from 'uuid/v4';


const cardSource = {
	beginDrag(props) {
		return {
			id:false,
			text: props.text,
			type: props.type,
			new:true,
			settings: props.settings,
			dragType: props.dragType,
		};
	},
	endDrag(props, monitor) {
	    const { id: droppedId, originalIndex } = monitor.getItem();
	    const didDrop = monitor.didDrop();

	    if (!didDrop) {
	    	props.removeElement(monitor.getItem());
	    }
	}
};

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	};
}

const propTypes = {
	text: PropTypes.string.isRequired,

	// Injected by React DnD:
	isDragging: PropTypes.bool.isRequired,
	connectDragSource: PropTypes.func.isRequired
};

class DraggableElement extends React.Component {
	render() {
		const { isDragging, connectDragSource, text, icon,image } = this.props;
		return connectDragSource(
			<div className="col-sm-3 draggable-component text-center" style={{ opacity: isDragging ? 0.5 : 1 }}>
				<img style={{width:'70px'}} src={image} />
				<div style={{paddingTop:'6px'}}>{text}</div>
			</div>
		);
	}
}

DraggableElement.propTypes = propTypes;

// Export the wrapped component:
export default DragSource((props) => props.dragType, cardSource, collect)(DraggableElement);


// WEBPACK FOOTER //
// ./components/builder/DraggableElement.js